import { Component, OnInit } from '@angular/core';
import {TranslateService} from "../../../translate.service";
import {AppConfigService} from "../../../../config/app-config.service";
import {FiltersService} from "../../../../search/search-list/filters/filters.service";
import {FacetService} from "../../facets/facet.service";
import {Filter} from '../../../../search/search-list/filters/filter-block/filter-item/filter';

@Component({
  selector: 'app-choosen-facets',
  templateUrl: './choosen-facets.component.html',
  styleUrls: ['./choosen-facets.component.scss']
})
export class ChoosenFacetsComponent implements OnInit {

  filters: Filter[] = [];

  hasSelected = false;

  constructor(
    public facetService: FacetService,
    public appConfigService: AppConfigService,
    public translateService: TranslateService) {
  }

  ngOnInit() {
    this.facetService.allRegularFacets.subscribe(filters => {
      this.filters = filters.filter(filter => !filter.hideInResult);
      this.hasSelected = !!this.filters.find(filter => filter.selected);
    });
  }

}
